import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "key-points-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "key-points-column"
}
const _hoisted_3 = { class: "title-wrapper" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "description" }
const _hoisted_6 = {
  key: 0,
  class: "conclusion"
}
const _hoisted_7 = {
  key: 1,
  class: "key-points-column"
}
const _hoisted_8 = {
  key: 0,
  class: "doc-name"
}
const _hoisted_9 = { class: "generation-error" }
const _hoisted_10 = { class: "error-message" }

import AnimatedDots from '@/components/common/animated-dots/AnimatedDots.vue';
import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import BotMessageHeader from '@/components/common/bot-message-header/BotMessageHeader.vue';
import FloatingCard from '@/components/common/floating-card/FloatingCard.vue';
import CustomTooltip from '@/components/common/tooltip/CustomTooltip.vue';
import ReferenceDots from '@/components/Reviewing/reference-dots/ReferenceDots.vue';
import { KeyPoint } from '@/models/doc-review';
import documentReviewingService from '@/services/DocumentReviewingService';
import { useReviewingStore } from '@/stores/reviewingStore';
import { useReferenceSelectionStore } from '@/stores/useReferenceSelectionStore';
import { useToasterStore } from '@/stores/useToasterStore';
import { GlobalErrorHandler } from '@/utils/global-error.utils';
import { OfficeUtils } from '@/utils/office.utils';
import { v4 as uuidv4 } from 'uuid';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useKeyPointsExport } from '@/composables/useKeyPointsExport';
import IconButton from '@/components/common/button/IconButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'KeyPoints',
  setup(__props) {

const loading = ref(false);
const reviewingStore = useReviewingStore();
const keyPoints = ref<KeyPoint[]>([]);
const conclusion = ref<string | undefined>();
const documentName = ref<string | undefined>();
const toaster = useToasterStore();
const referenceStore = useReferenceSelectionStore();
const { t } = useI18n();
const { onCopyKeypoints, onInsertKeypoints } = useKeyPointsExport();

const loadKeypoints = async () => {
  loading.value = true;
  try {
    if (reviewingStore.keyPointsResponse.keyPoints.length) {
      keyPoints.value = reviewingStore.keyPointsResponse.keyPoints;
      conclusion.value = reviewingStore.keyPointsResponse.conclusion;
    } else {
      const paragraphs = await OfficeUtils.getDocumentParagraphs();
      const apiResponse =
        await documentReviewingService.getDocumentKeypoints(paragraphs);
      keyPoints.value = apiResponse.keyPoints;

      conclusion.value = apiResponse.conclusion;
      reviewingStore.setKeypointsResponse(apiResponse);
    }
  } catch (error) {
    console.error(error);
    await GlobalErrorHandler.handleError(error, toaster, t);
  } finally {
    if (keyPoints.value.length) {
      keyPoints.value.forEach((keyPoint) => {
        keyPoint.id = uuidv4();
      });
    }
    loading.value = false;
  }
};

loadKeypoints();
documentName.value = OfficeUtils.getDocumentName();

const onResetKeypoints = () => {
  reviewingStore.setKeypointsResponse({ keyPoints: [], conclusion: '' });
  loadKeypoints();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!loading.value)
      ? (_openBlock(), _createBlock(FloatingCard, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(BotMessageHeader, {
              title: _ctx.$t('reviewing.key_points.tab_title')
            }, {
              actions: _withCtx(() => [
                _createVNode(IconButton, {
                  "icon-name": "copy-text",
                  "tooltip-message": _ctx.$t('legal_assistant.actions.copy'),
                  onClick: _unref(onCopyKeypoints)
                }, null, 8, ["tooltip-message", "onClick"]),
                _createVNode(IconButton, {
                  "icon-name": "insert-text",
                  "tooltip-message": _ctx.$t('legal_assistant.actions.insert'),
                  onClick: _unref(onInsertKeypoints)
                }, null, 8, ["tooltip-message", "onClick"])
              ]),
              _: 1
            }, 8, ["title"]),
            (keyPoints.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(keyPoints.value, (keyPoint, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass([
            'key-point',
            {
              active: _unref(referenceStore).selectedReference?.renderId === keyPoint.id
            }
          ]),
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("p", _hoisted_4, _toDisplayString(keyPoint.title), 1),
                        _createVNode(CustomTooltip, {
                          message: keyPoint.explanation,
                          position: "top",
                          "allow-multi-line": true
                        }, {
                          default: _withCtx(() => [
                            _createVNode(AppIcon, {
                              "class-name": "help-icon",
                              name: "info"
                            })
                          ]),
                          _: 2
                        }, 1032, ["message"])
                      ]),
                      _createElementVNode("p", _hoisted_5, _toDisplayString(keyPoint.description), 1),
                      _createVNode(ReferenceDots, {
                        referencedParagraphs: keyPoint.references,
                        onResetReview: onResetKeypoints,
                        "render-id": keyPoint.id!
                      }, null, 8, ["referencedParagraphs", "render-id"])
                    ], 2))
                  }), 128)),
                  (conclusion.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(conclusion.value), 1))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (documentName.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(documentName.value), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('reviewing.key_points.error')), 1),
                    _createVNode(AppIcon, {
                      "class-name": "re-generate-icon",
                      name: "counter-clock",
                      onClick: loadKeypoints
                    })
                  ])
                ]))
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(FloatingCard, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(BotMessageHeader, {
              title: _ctx.$t('reviewing.key_points.tab_title')
            }, null, 8, ["title"]),
            _createVNode(AnimatedDots)
          ]),
          _: 1
        }))
  ]))
}
}

})